import React from "react";

const InputError: React.FC<{ children: any }> = ({ children }) => {
    return <p className="text-red-400">{children}</p>
}

export default InputError;
